export const taskSpellcheckQuestions = {
	type: 'object',
	required: [
		'content',
		'words'
	],
	properties: {
		content: {
			type: 'string'
		},
		words: {
			type: 'array',
			items: {
				$ref: '/task-spellcheck-words'
			}
		}
	},
	errorMessage: {
		required: 'validationFieldRequired',
		properties: {
			content: 'validationFieldRequired'
		}
	}
};
